export const getLibrary = (provider) => {
  return provider
};
